import type { InfoScreenContent } from "@/types/infoScreen";
import type { InfoScreenEventsPayload, InfoScreenModule } from "@/types/infoScreenEvents";

const MIN_ROTATION_SECONDS = 5;
const MAX_VISIBLE_EVENTS = 6;

function clampRotationSeconds(seconds: number): number {
  return Math.max(MIN_ROTATION_SECONDS, seconds);
}

export function countEnabledInfoScreenPages(content: InfoScreenContent): number {
  return content.pages.filter((p) => p.enabled).length;
}

export function countVisibleInfoScreenEvents(events: InfoScreenEventsPayload["events"]): number {
  return Math.min(events.length, MAX_VISIBLE_EVENTS);
}

/**
 * Dauer, die ein Modul in der Gesamtrotation sichtbar bleibt.
 * Entspricht der Summe der Einzelanzeigen (Seiten bzw. Event-Karten),
 * damit der innere Rotator alle Inhalte einmal zeigen kann.
 */
export function infoScreenModuleRotationSeconds(
  mod: InfoScreenModule,
  content: InfoScreenContent,
  eventsPayload: InfoScreenEventsPayload | null,
): number {
  if (mod.type === "local_events" && eventsPayload) {
    const perItem = clampRotationSeconds(eventsPayload.rotation_seconds);
    const count = Math.max(1, countVisibleInfoScreenEvents(eventsPayload.events));
    return perItem * count;
  }

  if (mod.type === "pages") {
    const perPage = clampRotationSeconds(content.page_rotation_seconds);
    const count = Math.max(1, countEnabledInfoScreenPages(content));
    return perPage * count;
  }

  return clampRotationSeconds(content.page_rotation_seconds);
}
